module.exports = __webpack_public_path__ + "img/ch_step_operate_permission.b629fb48.png";